var lg_6711R1P072B_TV = {
    name: "6711R1P072B_TV",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [24,0,4,124,3,25,3,248,6,25,3,124,3,50,6,124,3,87,79,191,154,32],
        },
        {
            // function: "AV",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [24,0,4,124,3,25,3,248,6,25,3,124,3,50,6,124,3,87,79,190,118,32],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [24,0,5,124,3,25,3,248,6,25,3,124,3,50,6,248,6,50,6,124,3,62,76,191,152,132],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [24,0,4,124,3,25,3,248,6,25,3,124,3,50,6,124,3,87,79,190,94,32],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [24,0,4,124,3,25,3,248,6,25,3,124,3,50,6,124,3,62,76,190,92,136],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [24,0,4,124,3,25,3,248,6,25,3,124,3,50,6,124,3,87,79,191,46,32],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [24,0,4,124,3,25,3,248,6,25,3,124,3,50,6,124,3,62,76,191,44,136],
        },
    ]
}
export default lg_6711R1P072B_TV